const TEXT = {
  TITLE: {id: 'update.app.modal.tittle'},
  DESCRIPTION: {id: 'update.app.modal.text'},
  CTA_YES: {id: 'update.app.modal.CTA'},
  CTA_NO: {id: 'update.app.modal.later'},
};

export {TEXT};
